import createReactComponent from '../createReactComponent';
export default createReactComponent(
  'device-ipad-horizontal-cancel',
  'IconDeviceIpadHorizontalCancel',
  [
    [
      'path',
      {
        d: 'M12 20h-7a2 2 0 0 1 -2 -2v-12a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v6.5',
        key: 'svg-0',
      },
    ],
    ['path', { d: 'M9 17h3.5', key: 'svg-1' }],
    ['path', { d: 'M19 19m-3 0a3 3 0 1 0 6 0a3 3 0 1 0 -6 0', key: 'svg-2' }],
    ['path', { d: 'M17 21l4 -4', key: 'svg-3' }],
  ],
);
